import { Box, styled } from '@mui/material'

interface Props {
  isDefaultToolbarHidden?: boolean
  hideFooter?: boolean
  allowPageScroll?: boolean
  hasExternalHeader?: boolean
}

export const DataGridContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isDefaultToolbarHidden' && prop !== 'hideFooter' && prop !== 'allowPageScroll' && prop !== 'hasExternalHeader',
})<Props>(({ theme, isDefaultToolbarHidden, hideFooter, allowPageScroll, hasExternalHeader }) => ({
  flexGrow: 1,
  maxHeight: '100%',
  height: '100%',
  '& .MuiDataGrid-root': {
    '& > *:first-child': {
      borderTopLeftRadius: hasExternalHeader ? '0px' : '8px',
      borderTopRightRadius: hasExternalHeader ? '0px' : '8px',
    },
    '& > *:last-child': {
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
    },
  },

  '& .MuiDataGrid-row': {
    backgroundColor: theme.palette.neutralLight[0],
    borderBottom: `1px solid ${theme.palette.neutralLight[300]}`,
    cursor: 'pointer',
  },
  '& .MuiDataGrid-cell--editing': {
    backgroundColor: 'rgb(255,215,115, 0.19)',
    color: '#1a3e72',
    '& .MuiInputBase-root': {
      height: '100%',
    },
  },
  '& .Mui-error': {
    backgroundColor: `rgb(126,10,15, ${theme.palette.mode === 'dark' ? 0 : 0.1})`,
    color: theme.palette.error.main,
  },
  '& .MuiDataGrid-cell:first-of-type': {
    paddingLeft: 22,
  },
  '& .MuiDataGrid-cell:last-of-type': {
    paddingRight: 24,
  },
  '& .MuiDataGrid-cell:focus': {
    outline: 'none !important',
    borderBottom: 'none',
  },
  '& .MuiDataGrid-columnHeaders': {
    borderLeft: 'none',
  },
  '& .MuiDataGrid-columnHeaders .MuiDataGrid-columnHeader:first-of-type': {
    paddingLeft: '24px !important',
  },
  '& .MuiDataGrid-cellContent': {
    color: theme.palette.text.secondary,
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: 'transparent',
    color: theme.palette.neutralLight[900],
    fontSize: 12,
  },
  '& .MuiDataGrid-main': {
    padding: '4px',
    width: 'calc(100% + 8px)',
    marginLeft: '-4px',
    marginTop: '-4px',
    maxHeight: '100%',
    ...(isDefaultToolbarHidden === true && { borderRadius: '8px' }),
  },
  '& .MuiDataGrid-overlay': {
    background: 'transparent',
  },
  //
  '.MuiDataGrid-pinnedColumns': {
    zIndex: 1,
  },
  '.MuiDataGrid-columnHeaders': {
    border: '1px solid #E7E7ED',
    background: '#F6F7FA',
    zIndex: 0,
  },
  '.MuiDataGrid-virtualScrollerContent': {
    borderRadius: 0,
    height: '100%',
    p: 0,
    m: 0,
  },
  '.MuiDataGrid-main': {
    padding: 0,
    margin: 0,
    borderRadius: 0,
    width: 'calc(100%)',
    flexGrow: 1,
    maxHeight: '100%',
    height: '100%',
  },
  '.MuiDataGrid-virtualScroller': {
    borderRadius: hideFooter === true ? '0 0 8px 8px' : '0px',
    border: '1px solid #E7E7ED',
    borderTop: 'none',
    borderBottom: 'none',
    background: theme.palette.neutralLight[0],
    p: 0,
    m: 0,
  },

  '.MuiDataGrid-footerContainer': {
    p: 0,
    m: 0,
    border: '1px solid #E7E7ED',
    background: '#F6F7FA',
    borderRadius: 0,
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    maxHeight: '36px',
    boxShadow: '0px -2px 4px 0px #00000012',
  },
  '.MuiDataGrid-footerContainer .MuiTablePagination-root': {
    overflowY: 'hidden',
  },
  '.MuiDataGrid-pinnedColumnHeaders': {
    zIndex: 1,
    background: '#F6F7FA',
    boxShadow: 'none',
  },
  '& .MuiDataGrid-cell:focus-within': {
    borderBottom: `1px solid ${theme.palette.neutralLight[300]}`,
  },
  '& .MuiDataGrid-columnHeaderTitleContainerContent': {
    width: '100%',
  },
  '& .MuiDataGrid-virtualScroller': {
    ...(allowPageScroll === true && {
      overflowY: 'visible !important',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      scrollbarWidth: 'none',
    }),
  },
}))
